import { api } from 'data/api/api'

import { AuthenticateUserError } from '@marketplace-web/domain/identity-data'

import { Oauth2UserLoginArgs } from '../types/oauth2-user-login-args'

export const oauth2UserLogin = (args: Oauth2UserLoginArgs) =>
  api.post<{ redirect_to: string }, AuthenticateUserError>('/oauth2', args)
